import React from "react";
import { Button } from "antd";
import classNames from "classnames";

const FreeTrial = ({ className }) => {
  return (
    <section
      className={classNames(
        "bg-gradient-to-br from-blue-500 to-indigo-500 text-white text-center py-16",
        className
      )}
    >
      <div className="container space-y-8">
        <h2 className="text-3xl font-semibold">Ready to Get Started?</h2>
        <p className="text-lg">
          Sign up for a free trial at AdInterest.com and start unlocking
          actionable insights for your Facebook ad campaigns today!
        </p>
        <Button
          href="#signup"
          className="!h-10 !px-10 shadow-xl !font-medium rounded-xl"
          color="primary"
          variant="filled"
        >
          Start Your Free Trial
        </Button>
      </div>
    </section>
  );
};

export default FreeTrial;
